import { createTracker } from 'usage-tracker';
import { THEME_PREVIEWER_NAMESPACE } from '../constants/usage/standaloneTracking';
import { withSessionReplay } from 'usage-tracker-session-replay';
export const usageTracker = withSessionReplay(createTracker({
  standalone: true
}));
export const track = (event, properties) => {
  usageTracker.track(THEME_PREVIEWER_NAMESPACE, event, properties);
};